<template>
  <div id="app" class="reading-app">
    <div class="title">{{ infoObj.goodsName }}</div>
      <div class="goodsIntro" v-html="infoObj.goodsIntro"></div>
      <FootTab></FootTab>
  </div>
</template>

<script>
import FootTab from "@/components/FootTab.vue";
export default {
  name: 'ReadingApp',
  components: {
    FootTab,
  },
  data() {
    return {
      infoObj:null,
    };
  },
  mounted() {
    this.http
      .getBookDet({
        id: this.$route.query.id,
      })
      .then((res) => {
        console.log(res.data.data,'44');
        
        this.infoObj = res.data.data;
      });
  },
  methods:{
  },
};
</script>

<style scoped>
.title{
  text-align: center;
  font-size: 18px;
  padding: 20px 0;
  font-weight: bold;
}
.goodsIntro{
  text-align: left;
}
</style>